import { API } from '~apis/axios/instance';
import { AuthModel } from '~models/auth';
import { ResponseBase } from '~types/response';

interface Response extends ResponseBase {
  data: {
    email: string;
    password: string;
  };
}

/**
 * 비밀번호 변경
 * @link http://revenuemarket-apollo11-dev.eba-isum2qyp.ap-northeast-2.elasticbeanstalk.com/swagger-ui/index.html#/password-controller/resetPassword
 */
export default function postResetPassword(data: AuthModel.ResetPasswordRequest) {
  return API.post<Response>('/api/v2/users/password/reset-password', { data });
}
